<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
    </div>
    <div class="icerik" style="height: calc(100vh - 120px);">
      <div class="container-fluid mt-5">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <el-steps :active="AktifStep" finish-status="success">
              <el-step title="Dosya Seçimi" description="Excel Dosyanızı Seçiniz"></el-step>
              <el-step title="Kontrol & Onay" description="İçe Aktarım için kontrol edin"></el-step>
              <el-step title="Veri Geçişi" description="Aktarım sonucu"></el-step>
            </el-steps>
          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===1" class="mt-5">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Şimdi bir tık ile bütün verilerinizi aidatım'a aktarın.<br>
              Hazırladığınız şablon Excel dosyasını ön izlemeli olarak göstereceğiz.
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <label for="file" type="button" class="el-button el-button--success btn-block">
                  <i class="feather-upload"></i>
                  Excel Dosyası Yükle </label>
                <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls"
                       @change="ExcelSecimi">
              </el-col>
              <el-col :span="6">
                <el-button type="warning" class="btn-block" @click="ModalOlayi=true">
                  <i class="feather-edit"></i> {{ Sayfa.ButtonAdi }}
                </el-button>
              </el-col>
              <el-col :span="6">
                <a href="https://drive.google.com/uc?authuser=0&id=1dk6kUugz3BEkUbsEo9XJc1_i7b6mTAAa&export=download"
                   target="_blank" class="el-button text-primary btn-block">
                  <i class="feather-download"></i>
                  Şablon İndir
                </a>
              </el-col>
            </el-row>

          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===2" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Excel dosyanızı aşağıdaki tabloda derledik<br>
              Kontrol ederek içe aktarabilirsiniz.
            </div>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-button type="primary" @click="AktifStep=1" icon="el-icon-caret-left">Dosya Seçimine
                  Dön
                </el-button>
              </el-col>
              <el-col :span="8">
                <el-button type="success" @click="Onayla" class="float-right" icon="el-icon-check">
                  Onayla ve
                  içe Aktar
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <table class="table table-hover table-sm">
          <thead>
          <tr>
            <th colspan="4" class="text-center">Mesken Bilgi</th>
            <th colspan="9" class="text-center">Kişi Bilgi</th>
            <th colspan="4" class="text-center">Borç Bilgi</th>
            <th colspan="2" class="text-center">Emanet Bilgi</th>
          </tr>
          <tr>
            <th>No</th>
            <th>Kat</th>
            <th>M2</th>
            <th>Türü</th>
            <th>İsim Soyisim</th>
            <th>T.C.Kimlik/V.No</th>
            <th>V.Dairesi</th>
            <th>Telefon</th>
            <th>Mail</th>
            <th>Doğum Tarihi</th>
            <th>Ev Sahibi</th>
            <th>Giriş Tarihi</th>
            <th>Çıkış Tarihi</th>
            <th>Borç Tutar</th>
            <th>Kategori</th>
            <th>Zam Oran</th>
            <th>Son Ödeme Tarihi</th>
            <th>Emanet Tutar</th>
            <th>Kasa</th>
          </tr>

          </thead>
          <tbody>
          <tr v-for="(r, key) in data" v-if="key>1" :key="key">
            <td v-for="c in cols" :key="c.key"> {{ r[c.key] }}</td>
          </tr>
          </tbody>
        </table>


      </div>
      <div v-if="AktifStep===3" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div v-if="lo" class="alert alert-danger">Veriler işleniyor lütfen bekleyiniz.</div>
            <div v-if="!lo" class="alert alert-success">Verilerinizin geçişi tamamlandı<br>
              Bina artık aidatım'ı kullanmaya hazır.

            </div>
            <el-row>
              <el-col :span="24" v-if="!lo">
                <el-button type="success" @click="Yenile" class="float-right" icon="feather-airplay">
                  Bina Ekran
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <MeskenFormModal :Bina_id="Bina_id" @ModalOlayi="ModalOlayi=$event"
                       :ModalOlayi="ModalOlayi"></MeskenFormModal>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import MeskenFormModal from "./MeskenFormModal";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {MeskenFormModal},
  props: {
    Bina_id: String
  },
  data() {
    return {
      lo: false,
      ModalOlayi: null,
      AktifStep: 1,
      Sayfa: {
        Adi: 'Hızlı Kurulum Ekranı',
        ButtonAdi: 'Manuel Kurulum'
      },
      data: [],
      cols: [],
      options: [{
        label: 'Kişi Bilgi',
        options: [
          {value: 'AdSoyad', label: 'Ad Soyad'},
          {value: 'Telefon', label: 'Telefon'},
          {value: 'Mail', label: 'Mail'},
          {value: 'vDaire', label: 'Vergi Dairesi'},
          {value: 'vNo', label: 'T.C.Kimlik/Vergi No'},
          {value: 'dTarihi', label: 'Doğum Tarihi'},
          {value: 'gTarihi', label: 'Giriş Tarihi'},
          {value: 'cTarihi', label: 'Çıkış Tarihi'},
          {value: 'Sahip', label: 'Ev Sahibi'},
        ]
      }, {
        label: 'Mesken Bilgileri',
        options: [
          {value: 'No', label: 'Daire No'},
          {value: 'M2', label: 'Daire M2'},
          {value: 'Kat', label: 'Kat'},
          {value: 'Tur', label: 'Mesken Türü'}
        ]
      }, {
        label: 'Borç Bilgi',
        options: [
          {value: 'Kategori', label: 'Kategori'},
          {value: 'Tutar', label: 'Borç Tutar'},
          {value: 'SOTarihi', label: 'Son Ödeme Tarihi'}
        ]
      }],
      value: [],

    };
  },

  methods: {

    Yenile() {
      location.reload();
    },
    Hazirla() {

      if (this.value.length < 3) {
        this.$message.error('Excel Dosyasında Eksikler var');
      } else {
        this.AktifStep = 2;
      }
    },
    Onayla() {

      this.AktifStep = 3;
      this.lo = true;
      this.$store.dispatch("Post", {...this.data, path: 'yonetim/kurulum/bina/' + this.Bina_id})
        .then(response => {
          if (response.Durum == "OK") {
            this.lo = false;
            this.$emit("ModalOlayi", false);
            this.$message.success(response.Mesaj);
            this.$router.push('/yonetim/bina/' + this.Bina_id)
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    ExcelSecimi(evt) {
      const files = evt.target.files;
      if (files && files[0]) this._file(files[0]);
    },
    _file(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        //const wb = XLSX.read(bstr, {type: 'binary'});
        const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY"});
        //const data = XLSX.utils.sheet_to_json(ws, {header: 1});
        this.data = data;
        this.cols = make_cols(ws['!ref']);
        this.AktifStep = 2;
      };
      reader.readAsBinaryString(file);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Kurulum.vue